<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <!-- <h5 class="card-title font-weight-bold font-size-lg mb-4">Agency Service</h5> -->
            <form [formGroup]="agencyForm">
                <div class="row">

                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="station">Station *</label>
                            <ng-select id="station" required formControlName="station" [ngClass]="{'is-invalid': submitted && agencyFormcontrols.station.errors}" placeholder="Select Station" (onchange)="onStationChange($event)">
                                <!-- <ng-option [value]="'ALL'">
                                    ALL
                                </ng-option> -->
                                <ng-option *ngFor="let station of allStations" [value]="station.StationCode">
                                    {{station.STATIONID}} - {{station.AirportName}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.station">
                                <div class="error-message" *ngIf="agencyFormcontrols.station.hasError(validation.type) &&  ((agencyFormcontrols.station.dirty || agencyFormcontrols.station.touched))">
                                    {{validation.message}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="cn">Agency *</label>
                            <input id="cn" class="form-control" formControlName="company_Name" placeholder="Agency" type="text" [ngClass]="{'is-invalid': submitted && agencyFormcontrols.company_Name.errors}">
                            <div *ngFor="let validation of validation_messages.company_Name">
                                <div class="error-message" *ngIf="agencyFormcontrols.company_Name.hasError(validation.type) && ((agencyFormcontrols.company_Name.dirty  || agencyFormcontrols.company_Name.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

        </div>

        <div class="row">    

            <div class="col-md-4 col-sm-6">
                <div class="form-group">
                    <label for="cfn">Contact First Name *</label>
                    <input id="cfn" class="form-control" formControlName="contact_First_Name" placeholder="Contact First Name" type="text" [ngClass]="{'is-invalid': submitted && agencyFormcontrols.contact_First_Name.errors}">
                    <div *ngFor="let validation of validation_messages.contact_First_Name">
                        <div class="error-message" *ngIf="agencyFormcontrols.contact_First_Name.hasError(validation.type) && ((agencyFormcontrols.contact_First_Name.dirty  || agencyFormcontrols.contact_First_Name.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="form-group">
                    <label for="cln">Contact Last Name *</label>
                    <input id="cln" class="form-control" formControlName="contact_Last_Name" placeholder="Contact Last Name" type="text" [ngClass]="{'is-invalid': submitted && agencyFormcontrols.contact_Last_Name.errors}">
                    <div *ngFor="let validation of validation_messages.contact_Last_Name">
                        <div class="error-message" *ngIf="agencyFormcontrols.contact_Last_Name.hasError(validation.type) && ((agencyFormcontrols.contact_Last_Name.dirty  || agencyFormcontrols.contact_Last_Name.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>        
            <!-- minlength="10" maxlength="20" -->
            <div class="col-md-4 col-sm-6">
                <div class="form-group">
                    <label for="cp">Phone No *</label>
                    <input id="cp" class="form-control" formControlName="contact_Phone" placeholder=" Phone No" type="text" [ngClass]="{'is-invalid': submitted && agencyFormcontrols.contact_Phone.errors}">
                    <div *ngFor="let validation of validation_messages.contact_Phone">
                        <div class="error-message" *ngIf="agencyFormcontrols.contact_Phone.hasError(validation.type) && ((agencyFormcontrols.contact_Phone.dirty  || agencyFormcontrols.contact_Phone.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="col-lg-4 col-sm-6" *ngIf="isEditMode">
                <div class="form-group">
                    <label for="LCB">LCB ID</label>
                    <input id="LCB" class="form-control" formControlName="LCB_ID" placeholder="LCB ID" type="number" [ngClass]="{'is-invalid': submitted && f.LCB_ID.errors}">
                     <div *ngFor="let validation of validation_messages.LCB_ID">
                        <div class="error-message" *ngIf="f.LCB_ID.hasError(validation.type) && ((f.LCB_ID.dirty  || f.LCB_ID.touched))">
                            {{validation.message }}
                        </div>
                    </div> 
                </div>
            </div> -->
                              
                </div>

                <div class="row">   
                    
                     <!-- <div class="col-md-4 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="a_id">Agency ID *</label>
                            <input id="a_id" class="form-control" formControlName="agency_ID" placeholder="Agency ID" type="number">
                             <div *ngFor="let validation of validation_messages.agency_ID">
                                <div class="error-message" *ngIf="f.agency_ID.hasError(validation.type) && ((f.agency_ID.dirty  || f.agency_ID.touched))">
                                    {{validation.message }}
                                 </div>
                             </div> 
                        </div>
                     </div> -->

                    <div class="col-md-4 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="empid">Status *</label>
                            <ng-select  id="active" required formControlName="active" [ngClass]="{'is-invalid': submitted && agencyFormcontrols.active.errors}" placeholder="Select Status">
                                <ng-option *ngFor="let status of statusTypes" [value]="status.active">
                                    {{status.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                           
                </div>

                <div class="row">
                    <div class="col-md-12 py-3">
                        <!-- <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button> -->
                        <button id="saveAgencyBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddAgency(agencyForm.value)" *ngIf="!isEditMode">Add Agency</button>
                        <button id="updateAgencyBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateAgency(agencyForm.value)" *ngIf="isEditMode">Update Agency </button>
                        <!-- <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button> -->
                    </div>
                </div>
                
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>